import React, { useEffect, useState } from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSync } from '@fortawesome/pro-duotone-svg-icons';
import Axios from 'axios';
import { endOfDay } from 'date-fns';
import { useSnackbar } from 'notistack';
import { TitleLabel } from '../../Element/LabelInputForm';
import { MySelect } from '../../Select/Select';
import {
   activities_mock,
   groups_mock,
   fields_mock,
   departments_mock,
   segments_mock,
   branches_mock,
} from '../../../mockdata/dashboard/mock-graph-2';
import { enUS } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import { DatePicker, useDateInput } from 'react-nice-dates';
import dayjs from 'dayjs';
import { Input } from '../../../assets/styled/Element';

const url = '/GSB/dashboard/dashboard/GetDashboardDropdownLevel6';
let mock = false;

const Filter6level = ({
   year = null,
   isLoading = false,
   onSubmit,
   defaultSubmitFirstParams = false,
   isAllLevelSelectMultiple = false,
   startDate = new Date(moment().subtract(1, 'years')),
   endDate = new Date(),
}) => {
   // snackbar
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

   // dropdown options
   const [activities, setActivities] = useState([]);
   const [groups, setGroups] = useState([]);
   const [fields, setFields] = useState([]);
   const [departments, setDepartments] = useState([]);
   const [segments, setSegments] = useState([]);
   const [branches, setBranches] = useState([]);
   const [isLoadingActivities, setIsLoadingActivities] = useState(false);
   const [isLoadingGroups, setIsLoadingGroups] = useState(false);
   const [isLoadingFields, setIsLoadingFields] = useState(false);
   const [isLoadingDepartments, setIsLoadingDepartments] = useState(false);
   const [isLoadingSegments, setIsLoadingSegments] = useState(false);
   const [isLoadingBranches, setIsLoadingBranches] = useState(false);

   const {
      control,
      register,
      watch,
      setValue,
      getValues,
      handleSubmit,
      unsubscribe,
   } = useForm({
      defaultValues: {
         activity: null,
         group: null,
         field: null,
         department: null,
         segment: null,
         branch: null,
         startDate: startDate,
         endDate: endDate,
      },
   });

   const selectedActivity = watch('activity');
   const selectedGroup = watch('group');
   const selectedField = watch('field');
   const selectedDepartment = watch('department');
   const selectedSegment = watch('segment');
   const selectedBranch = watch('branch');
   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');

   useEffect(() => {
      register({ name: 'activity' });
      register({ name: 'group' });
      register({ name: 'field' });
      register({ name: 'department' });
      register({ name: 'segment' });
      register({ name: 'branch' });
      register({ name: 'startDate' });
      register({ name: 'endDate' });
   }, [register]);

   // on select date
   const handleStartDateChange = (e) => setValue('startDate', e);
   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') setValue('endDate', endOfDay(e));
      else setValue('endDate', e);
   };

   useEffect(() => {
      init();
   }, []);

   useEffect(() => {
      year && getActivities(year);
   }, [year]);

   const init = () => {
      if (defaultSubmitFirstParams) {
         (async () => {
            await getGroupsDropdown().then((result) => {
               handleChangeGroup(result[0]);
            });
            handleSubmit(submit)();
         })();
      } else {
         getGroupsDropdown();
      }
   };

   // transform dropdown
   const toDropdownShortcode = (arr) => {
      return arr.map((el) => {
         return {
            data: el,
            label: el.formattedName,
            value: el.shortCode,
         };
      });
   };

   const toDropdownActivity = (arr) => {
      return arr.map((el) => {
         return {
            data: el,
            label: el.activityNameTh,
            value: el.activityId,
         };
      });
   };

   // get activity
   const getActivities = (year) => {
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownActivity(activities_mock);
            setActivities(temp);
         }, 100);
      } else {
         let payload = { year };
         setIsLoadingActivities(true);
         return Axios.get('/GSB/dashboard/dashboard/GetActivityList', {
            params: payload,
         })
            .then((resp) => {
               let temp = toDropdownActivity(resp.data);
               setActivities(temp);
               return temp;
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingActivities(false);
            });
      }
   };

   // get dropdown
   const getGroupsDropdown = () => {
      let payload = {
         divisionShortCode: [],
         level: 2,
         start: null,
         limit: null,
      };
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownShortcode(groups_mock);
            setGroups(temp);
         }, 100);
      } else {
         setIsLoadingGroups(true);
         return Axios.post(url, payload)
            .then((resp) => {
               let temp = toDropdownShortcode(resp.data);
               setGroups(temp);
               return temp;
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingGroups(false);
            });
      }
   };
   const getFieldsDropdown = (shortCodes) => {
      let payload = {
         divisionShortCode: shortCodes,
         level: 3,
         start: null,
         limit: null,
      };
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownShortcode(fields_mock);
            setFields(temp);
         }, 100);
      } else {
         setIsLoadingFields(true);
         return new Promise((resolve, reject) =>
            Axios.post(url, payload)
               .then((resp) => {
                  let temp = toDropdownShortcode(resp.data);
                  setFields(temp);
                  resolve(temp);
               })
               .catch((e) => {
                  if (e.response) {
                     const response = e.response.data;
                     enqueueSnackbar(e.response.data.errorAppMessageTh, {
                        variant: 'error',
                     });
                  } else {
                     console.error('site error');
                  }
                  reject(e.response);
               })
               .finally(() => {
                  setIsLoadingFields(false);
               }),
         );
      }
   };
   const getDepartmentsDropdown = (shortCodes) => {
      let payload = {
         divisionShortCode: shortCodes,
         level: 4,
         start: null,
         limit: null,
      };
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownShortcode(departments_mock);
            setDepartments(temp);
         }, 100);
      } else {
         setIsLoadingDepartments(true);
         return new Promise((resolve, reject) =>
            Axios.post(url, payload)
               .then((resp) => {
                  let temp = toDropdownShortcode(resp.data);
                  setDepartments(temp);
                  resolve(temp);
               })
               .catch((e) => {
                  if (e.response) {
                     const response = e.response.data;
                     enqueueSnackbar(e.response.data.errorAppMessageTh, {
                        variant: 'error',
                     });
                  } else {
                     console.error('site error');
                  }
                  reject(e.response);
               })
               .finally(() => {
                  setIsLoadingDepartments(false);
               }),
         );
      }
   };
   const getSegmentsDropdown = (shortCodes) => {
      let payload = {
         divisionShortCode: shortCodes,
         level: 5,
         start: null,
         limit: null,
      };
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownShortcode(segments_mock);
            setSegments(temp);
         }, 100);
      } else {
         setIsLoadingSegments(true);
         return new Promise((resolve, reject) =>
            Axios.post(url, payload)
               .then((resp) => {
                  let temp = toDropdownShortcode(resp.data);
                  setSegments(temp);
                  resolve(temp);
               })
               .catch((e) => {
                  if (e.response) {
                     const response = e.response.data;
                     enqueueSnackbar(e.response.data.errorAppMessageTh, {
                        variant: 'error',
                     });
                  } else {
                     console.error('site error');
                  }
                  reject(e.response);
               })
               .finally(() => {
                  setIsLoadingSegments(false);
               }),
         );
      }
   };
   const getBranchesDropdown = (shortCodes) => {
      let payload = {
         divisionShortCode: shortCodes,
         level: 6,
         start: null,
         limit: null,
      };
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownShortcode(branches_mock);
            setBranches(temp);
         }, 100);
      } else {
         setIsLoadingBranches(true);
         return new Promise((resolve, reject) =>
            Axios.post(url, payload)
               .then((resp) => {
                  let temp = toDropdownShortcode(resp.data);
                  setBranches(temp);
                  resolve(temp);
               })
               .catch((e) => {
                  if (e.response) {
                     const response = e.response.data;
                     enqueueSnackbar(e.response.data.errorAppMessageTh, {
                        variant: 'error',
                     });
                  } else {
                     console.error('site error');
                  }
                  reject(e.response);
               })
               .finally(() => {
                  setIsLoadingBranches(false);
               }),
         );
      }
   };

   // on select activity
   const handleChangeActivity = (selected) => {
      if (selected && Array.isArray(selected)) {
         setValue('activity', selected);
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('activity') ||
            (getValues('activity') &&
               selected.value !== getValues('activity').value)
         ) {
            setValue('activity', selected);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('activity', null);
      }
   };

   // on select dropdown
   const handleChangeGroup = (selected) => {
      const clearNext = () => {
         setValue('field', null);
         setValue('department', null);
         setValue('segment', null);
         setValue('branch', null);
         setFields([]);
         setDepartments([]);
         setSegments([]);
         setBranches([]);
      };
      let shortCodes = [];
      if (selected && Array.isArray(selected)) {
         shortCodes = selected.map((el) => el.value);
         setIsLoadingGroups(true);
         getFieldsDropdown(shortCodes)
            .then(() => {
               setValue('group', selected);
            })
            .finally(() => {
               setIsLoadingGroups(false);
            });
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('group') ||
            (getValues('group') && selected.value !== getValues('group').value)
         ) {
            setValue('group', selected);
            clearNext();
            shortCodes = [selected.value];
            getFieldsDropdown(shortCodes);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('group', null);
         clearNext();
      }
   };
   const handleChangeField = (selected) => {
      const clearNext = () => {
         setValue('department', null);
         setValue('segment', null);
         setValue('branch', null);
         setDepartments([]);
         setSegments([]);
         setBranches([]);
      };
      let shortCodes = [];
      if (selected && Array.isArray(selected)) {
         shortCodes = selected.map((el) => el.value);
         setIsLoadingFields(true);
         getDepartmentsDropdown(shortCodes)
            .then(() => {
               setValue('field', selected);
            })
            .finally(() => {
               setIsLoadingFields(false);
            });
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('field') ||
            (getValues('field') && selected.value !== getValues('field').value)
         ) {
            setValue('field', selected);
            clearNext();
            shortCodes = [selected.value];
            getDepartmentsDropdown(shortCodes);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('field', null);
         clearNext();
      }
   };
   const handleChangeDepartment = (selected) => {
      const clearNext = () => {
         setValue('segment', null);
         setValue('branch', null);
         setSegments([]);
         setBranches([]);
      };
      let shortCodes = [];
      if (selected && Array.isArray(selected)) {
         shortCodes = selected.map((el) => el.value);
         setIsLoadingDepartments(true);
         getSegmentsDropdown(shortCodes)
            .then(() => {
               setValue('department', selected);
            })
            .finally(() => {
               setIsLoadingDepartments(false);
            });
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('department') ||
            (getValues('department') &&
               selected.value !== getValues('department').value)
         ) {
            setValue('department', selected);
            clearNext();
            shortCodes = [selected.value];
            getSegmentsDropdown(shortCodes);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('department', null);
         clearNext();
      }
   };
   const handleChangeSegment = (selected) => {
      const clearNext = () => {
         setValue('branch', null);
         setBranches([]);
      };
      let shortCodes = [];
      if (selected && Array.isArray(selected)) {
         shortCodes = selected.map((el) => el.value);
         setIsLoadingSegments(true);
         getBranchesDropdown(shortCodes)
            .then(() => {
               setValue('segment', selected);
            })
            .finally(() => {
               setIsLoadingSegments(false);
            });
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('segment') ||
            (getValues('segment') &&
               selected.value !== getValues('segment').value)
         ) {
            setValue('segment', selected);
            clearNext();
            shortCodes = [selected.value];
            getBranchesDropdown(shortCodes);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('segment', null);
         clearNext();
      }
   };
   const handleChangeBranch = (selected) => {
      const clearNext = () => {};
      let shortCodes = [];
      if (selected && Array.isArray(selected)) {
         shortCodes = selected.map((el) => el.value);
         setIsLoadingBranches(true);
         getBranchesDropdown(shortCodes)
            .then(() => {
               setValue('branch', selected);
            })
            .finally(() => {
               setIsLoadingBranches(false);
            });
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('branch') ||
            (getValues('branch') &&
               selected.value !== getValues('segment').value)
         ) {
            setValue('branch', selected);
            clearNext();
            shortCodes = [selected.value];
            getBranchesDropdown(shortCodes);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('branch', null);
         clearNext();
      }
   };

   const handleReset = () => {
      setActivities([]);
      setGroups([]);
      setFields([]);
      setDepartments([]);
      setSegments([]);
      setBranches([]);
      setValue('activity', null);
      setValue('group', null);
      setValue('field', null);
      setValue('department', null);
      setValue('segment', null);
      setValue('branch', null);
      setValue('startDate', startDate);
      setValue('endDate', endDate);
      init();
   };

   const submit = async (e) => {
      let params = e;

      /** build short codes */
      let shortCodes = null;
      if (e.branch) {
         shortCodes = e.branch;
      } else if (e.segment) {
         shortCodes = e.segment;
      } else if (e.department) {
         shortCodes = e.department;
      } else if (e.field) {
         shortCodes = e.field;
      } else if (e.group) {
         shortCodes = e.group;
      } else {
         shortCodes = null;
      }
      if (shortCodes) {
         if (Array.isArray(shortCodes)) {
            shortCodes = shortCodes.map((el) => el.value);
         } else {
            shortCodes = [shortCodes.value];
         }
      }
      params.shortCodes = shortCodes;

      /** build activity */
      params.activity = e.activity && e.activity.data;

      /** build date */
      params.startDateString = moment(e.startDate).format('DD/MM/YYYY');
      params.endDateString = moment(e.endDate).format('DD/MM/YYYY');

      onSubmit(params);
   };

   return (
      <Box fontSize={20}>
         <form onSubmit={handleSubmit(submit)}>
            <Grid container spacing={2}>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>เลือกกิจกรรม&nbsp;:&nbsp;</TitleLabel>
                  <MySelect
                     closeMenuOnSelect
                     options={activities}
                     placeholder={'เลือกกิจกรรม'}
                     isLoading={isLoadingActivities}
                     isDisabled={false}
                     value={selectedActivity}
                     onChange={handleChangeActivity}
                     isMulti={false}
                  />
               </Grid>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>เลือกกลุ่ม&nbsp;:&nbsp;</TitleLabel>
                  <MySelect
                     closeMenuOnSelect={!isAllLevelSelectMultiple}
                     options={groups}
                     placeholder={'เลือกกลุ่ม'}
                     isLoading={isLoadingGroups}
                     isDisabled={false}
                     value={selectedGroup}
                     onChange={handleChangeGroup}
                     isMulti={isAllLevelSelectMultiple}
                  />
               </Grid>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>เลือกสายงาน&nbsp;:&nbsp;</TitleLabel>
                  <MySelect
                     closeMenuOnSelect={!isAllLevelSelectMultiple}
                     options={fields}
                     placeholder={'เลือกสายงาน'}
                     isLoading={isLoadingFields}
                     isDisabled={!getValues('group')}
                     value={selectedField}
                     onChange={handleChangeField}
                     isMulti={isAllLevelSelectMultiple}
                  />
               </Grid>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>
                     เลือกฝ่าย/ภาค&nbsp;:&nbsp;
                  </TitleLabel>
                  <MySelect
                     closeMenuOnSelect={!isAllLevelSelectMultiple}
                     options={departments}
                     placeholder={'เลือกฝ่าย/ภาค'}
                     isLoading={isLoadingDepartments}
                     isDisabled={!getValues('field')}
                     value={selectedDepartment}
                     onChange={handleChangeDepartment}
                     isMulti={isAllLevelSelectMultiple}
                  />
               </Grid>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>
                     เลือกส่วน/เขต&nbsp;:&nbsp;
                  </TitleLabel>
                  <MySelect
                     closeMenuOnSelect={!isAllLevelSelectMultiple}
                     options={segments}
                     placeholder={'เลือกส่วน/เขต'}
                     isLoading={isLoadingSegments}
                     isDisabled={!getValues('department')}
                     value={selectedSegment}
                     onChange={handleChangeSegment}
                     isMulti={isAllLevelSelectMultiple}
                  />
               </Grid>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>
                     เลือกหน่วยงาน/สาขา&nbsp;:&nbsp;
                  </TitleLabel>
                  <MySelect
                     closeMenuOnSelect={!isAllLevelSelectMultiple}
                     options={branches}
                     placeholder={'เลือกหน่วยงาน/สาขา'}
                     isLoading={isLoadingBranches}
                     isDisabled={!getValues('segment')}
                     value={selectedBranch}
                     onChange={handleChangeBranch}
                     isMulti={isAllLevelSelectMultiple}
                  />
               </Grid>
               <Grid item xs={2}>
                  <TitleLabel Fs={'14px'}>เริ่มต้น&nbsp;:&nbsp;</TitleLabel>
                  <Box width={'100%'} style={{ position: 'relative' }}>
                     <DatePicker
                        date={selectStartDate}
                        onDateChange={handleStartDateChange}
                        locale={enUS}
                        maximumDate={getValues('endDate')}
                     >
                        {({ inputProps, focused }) => (
                           <Input
                              className={'input' + (focused ? ' -focused' : '')}
                              {...inputProps}
                              value={`${
                                 inputProps.value &&
                                 dayjs(new Date(inputProps.value)).format(
                                    'DD/MM/BBBB',
                                 )
                              }`}
                           />
                        )}
                     </DatePicker>
                  </Box>
               </Grid>
               <Grid item xs={2}>
                  <TitleLabel Fs={'14px'}>สิ้นสุด&nbsp;:&nbsp;</TitleLabel>
                  <Box width={'100%'} style={{ position: 'relative' }}>
                     <DatePicker
                        date={selectEndDate}
                        onDateChange={handleEndDateChange('auto')}
                        minimumDate={
                           getValues('startDate')
                              ? getValues('startDate')
                              : new Date()
                        }
                        locale={enUS}
                     >
                        {({ inputProps, focused }) => (
                           <Input
                              className={'input' + (focused ? ' -focused' : '')}
                              {...inputProps}
                              value={`${
                                 inputProps.value &&
                                 dayjs(new Date(inputProps.value)).format(
                                    'DD/MM/BBBB',
                                 )
                              }`}
                           />
                        )}
                     </DatePicker>
                  </Box>
               </Grid>
            </Grid>
            <Grid container spacing={2}>
               <Grid item xs={12}>
                  <Button
                     variant={'contained'}
                     size={'small'}
                     color={'primary'}
                     type={'submit'}
                     startIcon={
                        isLoading ? (
                           <CircularProgress size={20} color={'primary'} />
                        ) : (
                           <FontAwesomeIcon icon={faSearch} size={'s'} />
                        )
                     }
                     disabled={isLoading}
                  >
                     ค้นหา
                  </Button>
                  <Button
                     variant={'contained'}
                     disableElevation
                     size={'small'}
                     onClick={handleReset}
                     startIcon={<FontAwesomeIcon icon={faSync} size={'s'} />}
                  >
                     รีเฟรช
                  </Button>
               </Grid>
            </Grid>
         </form>
      </Box>
   );
};

export default Filter6level;
